import React, { useState } from 'react'
import API from '../../utils/API'
import withNavigate from '../../components/common/withNavigate'

function Activate(props) {
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  const [submitted, setSubmitted] = useState(false)

  // Password validation
  const [passwordValid, setPasswordValid] = useState(false);
  const [passwordConfirmValid, setPasswordConfirmValid] = useState(false);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    validatePassword(e.target.value);
  };
  
  const handlePasswordConfirmChange = (e) => {
    setPasswordConfirm(e.target.value);
    validatePasswordConfirm(e.target.value);
  };

  const validatePassword = (value) => {
    // Password valid as long as it is not empty
    setPasswordValid(value.length > 0);
    // setPasswordValid(value === "" || value === undefined || value === null || value.length >= passwordLength);
    validatePasswordConfirm(passwordConfirm); // Trigger password confirm validation
  };
  
  const validatePasswordConfirm = (value) => {
    setPasswordConfirmValid(value === password);
  };

  const handleSubmit = () => {
    if (
      passwordValid &&
      passwordConfirmValid
    ) {
      API.activate({ password})
        .then(res => {
          const { data } = res
          if (data.error) return setError(data.error)
          console.log(data);
          setSuccess('Success!');
          setError('');
          props.navigate('/')
        }).catch(err => {
          console.error(err)
          setSuccess('');
          setError(err.message)
        }
      )
    } else {
      setSuccess('');
      setError('Please address the errors above')
    }
    setSubmitted(true);
  }

  return (
    <div>
      <div className='password container py-5 h-100'>
        <div className='row d-flex justify-content-center p-3'>
          <div className='col-xl-4'>
            <form>
              <div className='header text-center mb-4'>
                <h2>Activate User</h2>
              </div>
              <div className='card'>
                <div className='form-outline mb-4'>
                  <label className='form-label' id='passwordLabel' htmlFor='newPassword'>New password:</label>
                  <input className={`form-control ${submitted && passwordValid ? "is-valid" : submitted && !passwordValid ? "is-invalid" : ""}`}  id='passwordField' value={password} name='password' onChange={handlePasswordChange} />
                  <div className="invalid-feedback">Please enter a valid password</div>
                </div>
                <div className='form-outline mb-4'>
                  <label className='form-label' id='confirmPasswordLabel' htmlFor='newPassword'>Confirm password:</label>
                  <input className={`form-control ${submitted && passwordConfirmValid ? "is-valid" : submitted && !passwordConfirmValid ? "is-invalid" : ""}`} id='confirmPasswordField' value={passwordConfirm} name='passwordConfirm' onChange={handlePasswordConfirmChange} />
                  <div className="invalid-feedback">Password do not match</div>
                </div>
                {success ? <p className='text-center text-success'>{success}</p> : null}
                {error ? <p className='error'>ERROR: {error}</p> : null}
                <button type='button' className='btn btn-primary btn-block mb-1' data-bs-toggle="modal" data-bs-target="#checkEmailModal" onClick={handleSubmit}>Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withNavigate(Activate)